var _rect, _rect2, _rect3, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnrampdelayed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 37,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 37,
    fill: "url(#paint0_linear_6004_368134)",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 37,
    fill: "url(#paint1_linear_6004_368134)",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9969 18.4984C26.7796 18.4984 18.4969 26.7812 18.4969 36.9984C18.4969 47.2157 26.7796 55.4984 36.9969 55.4984C47.2141 55.4984 55.4969 47.2157 55.4969 36.9984C55.4969 26.7812 47.2141 18.4984 36.9969 18.4984ZM14.7969 36.9984C14.7969 24.7377 24.7362 14.7984 36.9969 14.7984C49.2576 14.7984 59.1969 24.7377 59.1969 36.9984C59.1969 49.2592 49.2576 59.1984 36.9969 59.1984C24.7362 59.1984 14.7969 49.2592 14.7969 36.9984Z",
    fill: "url(#paint2_linear_6004_368134)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4625 26.5329C48.185 27.2553 48.185 28.4267 47.4625 29.1492L38.305 38.3067C37.5826 39.0291 36.4112 39.0291 35.6887 38.3067C34.9663 37.5842 34.9663 36.4128 35.6887 35.6904L44.8462 26.5329C45.5687 25.8104 46.7401 25.8104 47.4625 26.5329Z",
    fill: "url(#paint3_linear_6004_368134)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5969 9.24844C29.5969 8.22671 30.4251 7.39844 31.4469 7.39844H42.5469C43.5686 7.39844 44.3969 8.22671 44.3969 9.24844C44.3969 10.2702 43.5686 11.0984 42.5469 11.0984H31.4469C30.4251 11.0984 29.5969 10.2702 29.5969 9.24844Z",
    fill: "url(#paint4_linear_6004_368134)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6004_368134",
    x1: 33.797,
    y1: -7.16129,
    x2: 79.5922,
    y2: 9.19047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DABFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DABFEE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6004_368134",
    x1: 41.197,
    y1: 80.5645,
    x2: 2.22638,
    y2: 62.9472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6BDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BDEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6004_368134",
    x1: 59.2041,
    y1: 7.40692,
    x2: 8.01356,
    y2: 51.2846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#729AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A27AE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6004_368134",
    x1: 59.2041,
    y1: 7.40692,
    x2: 8.01356,
    y2: 51.2846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#729AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A27AE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6004_368134",
    x1: 59.2041,
    y1: 7.40692,
    x2: 8.01356,
    y2: 51.2846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#729AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A27AE9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnrampdelayed);
export default __webpack_public_path__ + "static/media/onrampdelayed.5b033c3e034c4f31adc2ccf042c91abc.svg";
export { ForwardRef as ReactComponent };